import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';

export const selectAnnouncement = createSelector(
  ({ announcement }: RootState) => ({ announcement }),
  ({ announcement }) => announcement
);
